import { render, staticRenderFns } from "./IMInfo.vue?vue&type=template&id=dbea8c98&"
import script from "./IMInfo.vue?vue&type=script&lang=js&"
export * from "./IMInfo.vue?vue&type=script&lang=js&"
import style0 from "./IMInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports